module.exports = __webpack_public_path__ + "img/slot_fachai.6264ab62.png";